module.exports = __webpack_public_path__ + "img/logo-pemex-og.2eaed7df.png";